export var GLOBAL = {
    url: 'http://localhost/api-laravel/public/api/'
};